import React from "react";
import { UnsubscribeThanks } from "~/organisms/UnsubscribeThanks";

const UnsubscribeContactThanksPage: React.FC = () => <UnsubscribeThanks />;

export default UnsubscribeContactThanksPage;
